'use client'

import { Carousel } from 'react-bootstrap'
import { useInView } from 'react-intersection-observer'
import { useGetSlidersHomeQuery } from '@/shared/api-rtk/index.js'
import { redirect } from 'next/navigation'
import { useEffect, useState } from 'react'
import { IMAGE_DIR } from '@/shared/constants/linksApi'
import cl from 'classnames'

export function HomepageCarousel({ onMount }) {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    const navigate = (path) => redirect(path)

    const { data: response, isLoading } = useGetSlidersHomeQuery()
    const [sliders, setSliders] = useState(null)

    useEffect(() => {
        if (response && response.result === 'success') {
            setSliders(Object.values(response.data))
            setTimeout(() => onMount(), 500)
        }
    }, [response])

    return (
        <Carousel
            data-bs-theme="dark"
            indicators={false}
            keyboard={true}
            pause={'hover'}
            touch={true}
            fade={true}
            interval={3000}
            className={cl(
                inView && 'animate__animated animate__fadeIn',
                'HomepageCarousel'
            )}
        >
            {!isLoading &&
                sliders?.map((slider) => {
                    const cutImageLink = slider.image.replaceAll(' ', '%20')
                    return (
                        <Carousel.Item
                            style={{ cursor: 'pointer' }}
                            key={slider.banner_image_id}
                        >
                            <a href={slider.link} target={'_blank'}>
                                <img
                                    src={IMAGE_DIR + cutImageLink}
                                    alt={slider.image}
                                />
                            </a>
                        </Carousel.Item>
                    )
                })}
        </Carousel>
    )
}
